import { Link } from "react-router-dom";

export default function PublicFooter() {
  return (
    <footer
      data-testid="public-footer"
      className="bg-[#07111F] border-t border-white/5 text-white/60"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid grid-cols-2 md:grid-cols-6 gap-10">
        <div className="col-span-2">
          <div className="text-white tracking-[0.18em] text-sm mb-4">
            KINNTEGRA
          </div>
          <p className="text-sm leading-relaxed max-w-sm">
            Infrastructure for the future of independent MFD businesses.
            Reporting, operations, continuity, and succession — built for
            enterprises that endure.
          </p>
          <div className="mt-6 text-xs text-white/40">
            © {new Date().getFullYear()} Kinntegra. All rights reserved.
          </div>
        </div>

        <FooterCol
          title="Platform"
          items={[
            { label: "MFD", to: "/mfd" },
            { label: "Features", to: "/features" },
            { label: "Private Investors", to: "/private-investors" },
            { label: "About", to: "/about" },
          ]}
        />
        <FooterCol
          title="For MFDs"
          items={[
            { label: "Connect With Us", to: "/mfd?get-started=mfd" },
            { label: "Login", to: "/login" },
          ]}
        />
        <FooterCol
          title="Legal"
          items={[
            { label: "Terms", to: "/about#terms" },
            { label: "Privacy", to: "/about#privacy" },
          ]}
        />
        <FooterCol
          title="Knowledge Center"
          items={[
            {
              label: "Mutual Fund",
              href: "https://www.amfiindia.com/investor#online-centre",
              external: true,
            },
          ]}
        />
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 text-[11px] tracking-wide text-white/40">
          Beyond Reporting. Building the Future of Independent MFD
          Businesses.
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, items }) {
  return (
    <div>
      <div className="text-xs uppercase tracking-[0.18em] text-white/40 mb-4">
        {title}
      </div>
      <ul className="space-y-3">
        {items.map((i) => {
          const testId = `footer-link-${i.label.toLowerCase().replace(/\s/g, "-")}`;
          if (i.external) {
            return (
              <li key={i.label}>
                <a
                  href={i.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-white/70 hover:text-[#C8A96B] transition"
                  data-testid={testId}
                >
                  {i.label}
                </a>
              </li>
            );
          }
          return (
            <li key={i.label}>
              <Link
                to={i.to}
                className="text-sm text-white/70 hover:text-[#C8A96B] transition"
                data-testid={testId}
              >
                {i.label}
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
